import React, { useState } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  InputGroup,
  Dropdown,
  Button,
} from "react-bootstrap";

import {
  BsThreeDotsVertical,
  BsSearch,
  BsEmojiSmile,
  BsSend,
  BsMic,
  BsArrowReturnRight,
  BsFolder,
} from "react-icons/bs";
import ChatRightSection from "./ChatRightSection";

const chatsData = [
  {
    id: 1,
    name: "Anthony Lewis",
    avatar: "/assets/img/profiles/avatar-29-1.jpg",
    message: "is typing...",
    time: "02:40 PM",
    online: true,
  },
  {
    id: 2,
    name: "Elliot Murray",
    avatar: "/assets/img/profiles/avatar-01-1.jpg",
    message: "Document",
    time: "06:12 AM",
  },
  {
    id: 3,
    name: "Stephan Peralt",
    avatar: "/assets/img/profiles/avatar-02-1.jpg",
    message: "Missed Video Call",
    time: "03:15 AM",
  },
  {
    id: 4,
    name: "Rebecca Smith",
    avatar: "/assets/img/profiles/avatar-18.jpg",
    message: "Hi how are you 🔥",
    time: "Sunday",
  },
  {
    id: 5,
    name: "Harvey Smith",
    avatar: "/assets/img/profiles/avatar-14-1.jpg",
    message: "Haha oh man 🔥",
    time: "03:15 AM",
  },
  {
    id: 6,
    name: "Linda Ray",
    avatar: "/assets/img/profiles/avatar-08-1.jpg",
    message: "Photo",
    time: "Wednesday",
  },
  {
    id: 7,
    name: "Doglas Martini",
    avatar: "/assets/img/profiles/avatar-07-1.jpg",
    message: "Incoming Video Call",
    time: "02:40 PM",
  },
  {
    id: 8,
    name: "Sarah Johnson",
    avatar: "/assets/img/profiles/avatar-03-1.jpg",
    message: "Sounds good! Let's discuss it tomorrow",
    time: "Yesterday",
  },
  {
    id: 9,
    name: "Michael Chen",
    avatar: "/assets/img/profiles/avatar-04-1.jpg",
    message: "Meeting scheduled for 3 PM",
    time: "12:30 PM",
  },
  {
    id: 10,
    name: "Jessica Williams",
    avatar: "/assets/img/profiles/avatar-05-1.jpg",
    message: "Thanks for the update!",
    time: "11:15 AM",
  },
];

const emojis = ["😀", "😍", "😎", "😂", "😜", "❤️", "👍", "👎"];

export default function ChatPage() {
  const [showSearch, setShowSearch] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedChat, setSelectedChat] = useState(chatsData[0]);
  const [messages, setMessages] = useState([
    {
      id: 1,
      type: "left",
      text: "Hi John, I wanted to update you on a new company policy.",
    },
    {
      id: 2,
      type: "right",
      text: "Sure, what’s the new policy?",
    },
  ]);

  const [input, setInput] = useState("");
  const [showEmoji, setShowEmoji] = useState(false);
  const [message, setMessage] = useState("");
  const [showMobileChat, setShowMobileChat] = useState(true);

  const filteredChats = chatsData.filter((c) =>
    c.name.toLowerCase().includes(search.toLowerCase()),
  );

  const sendMessage = (e) => {
    e.preventDefault();
    if (!message) return;

    setMessages([
      ...messages,
      { id: messages.length + 1, type: "right", text: message },
    ]);
    setMessage("");
  };

  const addEmoji = (emoji) => {
    setInput(input + emoji);
  };

  return (
    <Col style={{ background: "#f6f7fb", height: "100vh" }}>
      <Row className="h-100 g-0">
        {/* ================= LEFT SIDEBAR ================= */}

        <Col
          xs={12}
          sm={12}
          md={3}
          lg={4}
          className="border-end bg-white p-3 d-md-block"
          id="chatListCol"
          style={{
            display:
              showMobileChat || window.innerWidth >= 768 ? "block" : "none",
            position: window.innerWidth < 768 ? "absolute" : "relative",
            zIndex: 999,
            height: "100%",
          }}
        >
          <h5 className="mb-3">Chats</h5>

          <InputGroup className="mb-3">
            <Form.Control
              placeholder="Search For Contacts"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <InputGroup.Text>
              <BsSearch />
            </InputGroup.Text>
          </InputGroup>

          <div style={{ height: "80vh", overflowY: "auto" }}>
            {filteredChats.map((chat) => (
              <div
                key={chat.id}
                className="d-flex align-items-center justify-content-between p-2 mb-2"
                style={{
                  cursor: "pointer",
                  borderRadius: "8px",
                  background:
                    selectedChat.id === chat.id ? "#eef2ff" : "transparent",
                }}
                onClick={() => {
                  setSelectedChat(chat);
                  if (window.innerWidth < 768) {
                    setShowMobileChat(false);
                  }
                }}
              >
                <div className="d-flex align-items-center flex-grow-1 min-w-0">
                  <img
                    src={chat.avatar}
                    alt=""
                    style={{
                      width: 45,
                      height: 45,
                      borderRadius: "50%",
                      marginRight: 10,
                      flexShrink: 0,
                    }}
                  />

                  <div style={{ overflow: "hidden" }}>
                    <div
                      style={{
                        fontWeight: 600,
                        fontSize: 14,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {chat.name}
                    </div>

                    <div
                      style={{
                        fontSize: 12,
                        color: "#777",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {chat.message}
                    </div>
                  </div>
                </div>

                <div style={{ fontSize: 12, color: "#888", flexShrink: 0 }}>
                  {chat.time}
                </div>
              </div>
            ))}
          </div>
        </Col>

        {/* ================= CHAT AREA ================= */}
        {/* 
        <Col
          xs={12}
          sm={12}
          md={9}
          lg={9}
          className="d-flex flex-column"
          id="chatCol"
          style={{
            display:
              window.innerWidth < 768
                ? showMobileChat
                  ? "none"
                  : "flex"
                : "flex",
          }}
        >
    
        </Col> */}
        <ChatRightSection />
      </Row>

      <style>
        {`
.messageBox:hover .messageActions{
display:flex !important;
}

.dropdown-toggle::after{
display:none !important;
}

.message-wrapper{
display: flex !important;
}

.message-wrapper:hover .message-icon {
opacity: 1 !important;
}

.message-icon {
opacity: 0;
transition: opacity 0.2s ease-in-out;
}

@media (max-width: 768px) {
  #chatListCol {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: 999;
    background: white;
  }
  
  #chatCol {
    width: 100% !important;
  }
  
  .message-wrapper {
    margin-bottom: 12px;
    width: 100%;
  }
  
  .message-wrapper > div {
    max-width: 85% !important;
  }
  
  .chat-header {
    padding: 12px !important;
  }
  
  .chat-header h6 {
    font-size: 15px !important;
  }
  
  .flex-grow-1 {
    padding: 12px !important;
  }
  
  form {
    flex-wrap: wrap;
    gap: 8px !important;
    padding: 12px !important;
  }
  
  .emoji-picker {
    bottom: 80px !important;
    right: 10px !important;
    width: 180px !important;
  }

  /* Show icons on hover even on mobile */
  .message-wrapper .message-icon {
    opacity: 0;
  }

  .message-wrapper:active .message-icon,
  .message-wrapper:hover .message-icon {
    opacity: 1 !important;
  }
}

@media (max-width: 576px) {
  #chatCol {
    width: 100%;
  }
  
  .chat-header {
    padding: 10px !important;
  }
  
  .chat-header h6 {
    font-size: 13px !important;
  }

  .chat-header .d-flex {
    gap: 8px !important;
  }
  
  .flex-grow-1 {
    padding: 8px !important;
  }
  
  form {
    gap: 6px !important;
    padding: 8px !important;
  }

  .message-wrapper > div {
    max-width: 90% !important;
  }

  .message-wrapper {
    gap: 4px !important;
  }

  .message-wrapper .message-icon {
    font-size: 14px !important;
  }

  /* Input responsive sizing */
  form .form-control {
    flex: 1;
    min-width: 100px;
  }

  /* Ensure buttons remain clickable */
  .btn-sm {
    padding: 0.375rem 0.5rem !important;
    font-size: 0.75rem !important;
  }
}

@media (max-width: 480px) {
  .chat-header .d-flex {
    gap: 4px !important;
  }

  .chat-header {
    padding: 8px !important;
  }

  .flex-grow-1 {
    padding: 6px !important;
  }

  form {
    gap: 4px !important;
    padding: 6px !important;
  }

  .message-wrapper > div {
    max-width: 95% !important;
    gap: 2px !important;
  }
}
    
    `}
      </style>
    </Col>
  );
}
